declare const jQuery: any;
const $ = jQuery;
const $window = $(window);

type JQuery = any;

export function initCustomRadios(): void
{
	$("[data-custom-radio]").each(function () {
		initCustomRadio(this);
	});
}

export function initCustomRadio($origRadio, insertAfterOriginalInput = true): JQuery
{
	$origRadio = $($origRadio);
	const $customRadio = $(`<span class="custom-radio"><span></span></span>`);
	const checkedClass = "custom-radio-checked";
	const radioId: string = $origRadio.attr("id");
	const $label = $origRadio.closest("label").add(radioId ? $(`label[for="${radioId}"]`) : undefined);
	const defaultChecked: boolean = $origRadio.prop("checked");
	const $form = $customRadio.closest("form");
	const name: string = $origRadio.attr("name");

	if (defaultChecked)
	{
		$customRadio.addClass(checkedClass);
	}

	function check(): void
	{
		if ($origRadio.prop("checked"))
		{
			return;
		}
		if (!name)
		{
			$origRadio.prop("checked", true).trigger("change");
			return;
		}
		const selector: string = `input[type="radio"][name="${name}"]:checked`;
		const $checkedRadio = $form.length === 0 ? $(selector) : $form.find(selector);
		$checkedRadio.prop("checked", false).trigger("change");
		$origRadio.prop("checked", true).trigger("change");
	}

	const onChange = () => {
		if ($origRadio.prop("checked"))
		{
			$customRadio.addClass(checkedClass);
		}
		else
		{
			$customRadio.removeClass(checkedClass);
		}
	};

	$origRadio.on("change", onChange).css({ display: "none" });

	$form.on("reset", e => {
		setTimeout(onChange, 80);
	});

	$customRadio.add($label).click(ev => {
		ev.stopPropagation();
		check();
	});

	if (insertAfterOriginalInput)
	{
		$customRadio.insertAfter($origRadio);
	}

	return $customRadio;
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].initCustomRadio = initCustomRadio;
